import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import {
  Text, TextInput, Button, Icon,
} from 'react-orange-ui';

import WordingService from '../../../services/WordingService';
import OLink from '../../../orange-ui/components/Link/OLink';
import TitleWithCard from '../../Title/TitleWithCard';
import TagService from '../../../services/TagService';

class OtpView extends Component {
  state = {
    value: '',
    caption: '',
    hasRetry: false,
  };

  componentDidMount() {
    this.setState({
      caption: this.isMobile() ? WordingService.getWording('caption', 'otcSentBySms') : WordingService.getWording('caption', 'otcSentByMail'),
    });
  }

  componentDidUpdate(prevProps) {
    const { otc } = this.props;

    if (prevProps.otc !== otc) {
      this.setState({ hasRetry: true }, () => {
        setTimeout(() => {
          this.setState({ hasRetry: false });
        }, 10000);
      });
    }
  }

  isMobile = () => {
    const { contact } = this.props;
    return (contact.contactType.toLowerCase() === 'm');
  };

  /**
   * Set state value on input change
   * @param value
   */
  handleChange = (value) => {
    const { clearInputError, otcError, setInputError } = this.props;

    if (!otcError.valid) {
      clearInputError({ field: 'otc' });
    }
    if (value && !(/^\d+$/.test(value))) {
      setInputError({ field: 'otc', error: 'nan' });
    }
    this.setState({
      value: value.trim(),
    });
  };

  /**
   * Submit the user OTC, check if corresponding to the one sent
   * @param e
   */
  handleClick = (e) => {
    e.preventDefault();
    const { checkOtp } = this.props;
    const { value } = this.state;

    checkOtp({ otpCode: value });
  };

  /**
   * Set an input error when no code is filled on blur
   * Clear existing errors
   * @param e
   */
  handleBlur = (e) => {
    e.preventDefault();
    const { value } = this.state;
    const { setInputError } = this.props;

    if (!value) {
      setInputError({ field: 'otc', error: 'empty' });
    }
  };

  /**
   * Fucntion to send a new OTC, clear OTC value and error when exist
   */
  handleRetry = () => {
    const {
      otcError, sendOtp, contact, clearInputError,
    } = this.props;

    sendOtp({ contact });
    this.setState({ value: '' });
    if (!otcError.valid) {
      clearInputError({ field: 'otc' });
    }
  };

  render() {
    const { contact, isLoading, otcError } = this.props;
    const {
      value, caption, hasRetry,
    } = this.state;

    const isClickable = value.length > 0;
    return (
      <div id="otc-form">
        <Row>
          <Col xs={12} sm={12} md={9} lg={6} xl={6}>
            <TextInput
              id="otc-input"
              placeholder="6 chiffres"
              maxLength={6}
              value={value}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              valid={otcError.valid}
              errorMessage={otcError.errorMessage}
            >
              <TitleWithCard
                idLabel="otcLabel"
                idIcon="otcHelp"
                title={WordingService.getWording('title', this.isMobile() ? 'setSmsCode' : 'setMailCode')}
                hint={WordingService.getWording('hint', 'step3')}
                onIconClick={() => TagService.sendAction('helpOtc')}
              />
            </TextInput>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <br />
            <Text id="otc-message">
              {caption}
              <b id="otc-contact-view">
                {contact.contactView}
              </b>
              .
            </Text>
            <br />
            <Text id="otc-retry-message">
              {this.isMobile() ? WordingService.getWording('caption', 'noSmsReceived') : WordingService.getWording('caption', 'noMailReceived')}
              <OLink onClick={this.handleRetry} id="otc-retry-link">
                {WordingService.getWording('url', 'retrySendCode')}
              </OLink>
              .
            </Text>
            <br />
            { hasRetry && (
            <Text id="otc-retry-notification" bold size="s">
              <Icon icon="tick" color="green" style={{ marginRight: 10 }} />
              { WordingService.getWording('title', this.isMobile() ? 'smsWasResent' : 'mailWasResent') }
            </Text>
            )}
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm={12}>
            <Button id="btnSubmit" type="fill" onClick={this.handleClick} disabled={isLoading || !isClickable}>
              {WordingService.getWording('button', 'continue')}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

OtpView.defaultProps = {
  isLoading: false,
  otcError: {
    valid: true,
    errorMessage: '',
  },
  otc: {
    value: '',
    receivedAt: Date.now(),
  },
};

OtpView.propTypes = {
  /** Action calling the api partner to retry an otp */
  sendOtp: PropTypes.func.isRequired,
  /** Action to check the user otp with the one sent by partner */
  checkOtp: PropTypes.func.isRequired,
  /** Function to set an input error */
  setInputError: PropTypes.func.isRequired,
  /** Function to clear an input error */
  clearInputError: PropTypes.func.isRequired,
  /** Object contact data */
  contact: PropTypes.shape({
    contactId: PropTypes.string,
    contactView: PropTypes.string,
    contactType: PropTypes.string,
    contactValidity: PropTypes.string,
  }).isRequired,
  /** Boolean indicate if a request is currently loading */
  isLoading: PropTypes.bool,
  /** Object otc error */
  otcError: PropTypes.shape({
    valid: PropTypes.bool,
    errorMessage: PropTypes.string,
  }),
  /** Object otc */
  otc: PropTypes.shape({
    value: PropTypes.string,
    receivedAt: PropTypes.number,
  }),
};

export default OtpView;
